import { Component } from '@angular/core';

@Component({
  templateUrl: './sidenav.html'  
})
export class SidenavComponent { 
    constructor() { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/sidenav/sidenav-component.ts